// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ name: string; value: string }>;

export const DispatchUpdateFromWarehouseSrcNames: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/CheckoutReviewAndSubmit/UpdateFromWarehouseSrcNames",
        fromWarehouseSrcName: { name: props.parameter.name, value: props.parameter.value },
    });
};

export const chain = [DispatchUpdateFromWarehouseSrcNames];

const updateFromWarehouseSrcNames = createHandlerChainRunner(chain, "UpdateFromWarehouseSrcNames");
export default updateFromWarehouseSrcNames;
